import { Locale, Env } from '@shopee-user/global';
import { appendQueryToUrl } from '@shopee/url-util';
import { config as platformConfig } from '@shopee-user/platform';
import {
  THIRDPARTY_AUTH_PROVIDER_REDIRECT_URI,
  ThirdpartyBindingEntryPoint,
} from '../../service/constants';
const { BUSINESS_TARGET, ENV, LOCALE } = platformConfig;

import {
  BusinessTargetConfig,
  LocaleDomainSuffixConfig,
} from '@shopee-user/global';

// By using this function, we can ensure handle Global locale correctly
const getMappingToCLocale = (): Locale | null | undefined => {
  const { cidToLocaleMapping } = BusinessTargetConfig[BUSINESS_TARGET];
  for (const cid in cidToLocaleMapping) {
    if (cidToLocaleMapping[cid] === LOCALE) {
      return (Locale as any)[cid];
    }
  }
  return null;
};

const getShopeeOrigin = (): string | null => {
  const tocLocale = getMappingToCLocale();
  if (!tocLocale) {
    return null;
  }
  const origin =
    ENV === Env.Live
      ? `https://shopee.${LocaleDomainSuffixConfig[tocLocale]}`
      : `https://${ENV}.shopee.${LocaleDomainSuffixConfig[tocLocale]}`;

  return origin;
};

export const getShopeeWebOAuthUrl = ({
  clientId,
  scopes,
  language,
  entryPoint,
}: {
  clientId: string;
  scopes: string[];
  language?: string;
  entryPoint: ThirdpartyBindingEntryPoint;
}): string | null => {
  const shopeeOrigin = getShopeeOrigin();
  if (!shopeeOrigin) {
    return null;
  }
  const shopeeOAuthBaseUrl = `${shopeeOrigin}/integration/oauth`;

  // The account linkage page will handle the callback and navigate to service/third-party
  const redirectUri = THIRDPARTY_AUTH_PROVIDER_REDIRECT_URI[entryPoint];

  // Build Shopee OAuth URL with redirect URI as redirect_url parameter
  const authUrlParams: Record<string, string> = {
    client_id: clientId,
    scopes: JSON.stringify(scopes),
    redirect_url: redirectUri,
  };

  if (language) {
    authUrlParams.override_language = language;
  }

  return appendQueryToUrl(shopeeOAuthBaseUrl, authUrlParams);
};

export const getShopeeAppOAuthUrl = ({
  clientId,
  displayName,
  scopes,
  appCallbackUrl,
}: {
  clientId: string;
  displayName: string;
  scopes: string[];
  appCallbackUrl: string;
}) => {
  const shopeeOrigin = getShopeeOrigin();
  if (!shopeeOrigin) {
    return null;
  }
  // Universal Link, will open Shopee App or app download page
  const universalLink = `${shopeeOrigin}/universal-link/auth/auth-login`;
  return appendQueryToUrl(universalLink, {
    // OAuth parameters
    app_id: clientId,
    scopes: JSON.stringify(scopes),
    redirect_url: appCallbackUrl,
    display_name: displayName,
    // ULS parameters
    deep_and_deferred: 1, // will try open App by universal link first, then try shopee app deeplink if failed, then try to open App download page if still failed
    v4: 1, // use ULS v4
    uls_client: `tob-${__BUSINESS_TARGET__}`, // for ULS monitoring
  });
};
